/**
 * DOM viewport screenshot helper for Report Issue (T-002).
 */

import { domToBlob } from 'modern-screenshot';

export interface DomScreenshotResult {
    blob: Blob;
    objectUrl: string;
}

/** Capture the current viewport as PNG before any report dialog is shown. */
export async function captureDomScreenshot(): Promise<DomScreenshotResult | null> {
    try {
        const blob = await domToBlob(document.body, {
            width: window.innerWidth,
            height: window.innerHeight,
            style: {
                width: `${window.innerWidth}px`,
                height: `${window.innerHeight}px`,
            },
        });
        if (!(blob instanceof Blob)) {
            return null;
        }
        const objectUrl = URL.createObjectURL(blob);
        return { blob, objectUrl };
    } catch {
        return null;
    }
}

/** Convert a PNG blob to raw base64 (no data-URL prefix). */
export async function blobToRawBase64(blob: Blob): Promise<string> {
    const buffer = await blob.arrayBuffer();
    const bytes = new Uint8Array(buffer);
    let binary = '';
    for (let i = 0; i < bytes.length; i += 1) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
